const appendScript = (url, onReadyCallback) => {
  const targetScript = document.createElement('script');
  targetScript.type = 'text/javascript';
  if (targetScript.readyState) { // IE
    targetScript.onreadystatechange = () => {
      if (targetScript.readyState === 'loaded'
        || targetScript.readyState === 'complete') {
        targetScript.onreadystatechange = null;
        onReadyCallback();
      }
    };
  } else { // Non IE
    targetScript.onload = () => {
      onReadyCallback();
    };
  }

  targetScript.src = url;
  document.head.appendChild(targetScript);
};

export const appendNode = (...args) => {
  const AVAILABLE_ELEMENT_NODES = [ 'link', 'script' ];
  let tar = document.body;
  let tag;
  let attr;
  if (args.length === 0) {
    return null;
  }
  if (args.length < 3) {
    [ tag, attr = {} ] = args;
  } else {
    [ tar, tag, attr ] = args;
  }
  if (!AVAILABLE_ELEMENT_NODES.includes(tag)) return null;
  const dom = document.createElement(tag);
  Object.keys(attr).forEach(key => dom.setAttribute(key, attr[key]));
  return tar.appendChild(dom);
};

export const appendCss = config => appendNode(document.head, 'link', { type: 'text/css', rel: 'stylesheet', ...(typeof config === 'string' ? { href: config } : config) });

export const omit = (obj, omitKeys = []) => (
  Object.keys(obj).reduce(
    (acc, key) => (omitKeys.indexOf(key) === -1 ? Object.assign(acc, { [key]: obj[key] }) : acc),
    {},
  )
);

export default appendScript;
